"use client";

import { theme } from "@areahub/theme/src/theme";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";

const chakraTheme = extendTheme(theme);
export default function Chakra({ children }: { children: React.ReactNode }) {
  return <ChakraProvider theme={chakraTheme}>{children}</ChakraProvider>;
}
